import "./AppleHoliday.css";

function AppleHoliday() {
    return (
        <section className="apple-holiday cursorP">
            <div className="container-fluid">
                <div className="holiday-wrapper">
                    <div className="name1">Give WOW.</div>
                    <div className="name2">
                        This holiday season, find the perfect
                        <br />
                        for everyone on your list.
                    </div>
                    <div className="links-blue shopp">
                        <a href="https://www.apple.com/us/shop/goto/gifts">
                            Shop the gift guide
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AppleHoliday;
